import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#2882DE",
		style: { fill: "var(--color, #2882DE)" },
		d: "M11.6485 0.851472C12.1172 1.3201 12.1172 2.0799 11.6485 2.54853L5.04853 9.14853C4.5799 9.61716 3.8201 9.61716 3.35147 9.14853L0.351472 6.14853C-0.117157 5.6799 -0.117157 4.9201 0.351472 4.45147C0.820101 3.98284 1.5799 3.98284 2.04853 4.45147L4.2 6.60294L9.95147 0.851472C10.4201 0.382843 11.1799 0.382843 11.6485 0.851472Z"
	})
});
export default SvgSuccess;
